import { storeToRefs } from 'pinia'
import { useDmCoreSpaceOperatorStore } from '@nsftx/seven-client-retail-vue-dm-core'
import router from '..'
import { ROUTES_NAMES } from '../routesNames'

const operatorAuthGuard = () => {
  const { isOperatorLoggedIn } = storeToRefs(useDmCoreSpaceOperatorStore())

  router.beforeEach((to) => {
    if (!isOperatorLoggedIn.value && to.name !== ROUTES_NAMES.login) {
      return { name: ROUTES_NAMES.login }
    }
  })
}

export default operatorAuthGuard
